var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-card-container"},[(_vm.title)?_c('div',{staticClass:"app-card__out-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('v-card',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }